import templateUrl from './login.html';
import capitalize from 'lodash/capitalize';

export const loginComponent = {
	templateUrl,
	controller: class LoginComponent {
        constructor($state, AuthService, $location, toastr, ApiService){
            'ngInject';
            
            this.$state = $state;
            this.authService = AuthService;
            this.toastr = toastr;
            this.apiService = ApiService;
            this.username = '';
	        this.password = '';
            this.emailId = '';
            this.$location = $location;
            this.mismatchPswd = false;
            this.logo = "";
        }
	    $onInit() {
            this.forgotPasswordButtonDisabled = false;
	    }
        login() {
            this.authService
            .login(this.username, this.password)
            .then(() => {
                const redirect = this.authService.getLoginRedirect();
                if(redirect.length > 0){   
                    this.$location.url(redirect);
                    this.authService.setLoginRedirect('');
                }else{
                    this.$state.go('app.dashboard.DynamicMenus', {
                        url: 'home-banner'
                    });
                }
            }).catch((err) =>{
                this.errorMsg = capitalize(this.apiService.getErrorMessage(err));
            });
        }

        forgotPassword() {
            this.forgotPswd = true;
            this.successSubmit = false;
        }

        onSubmit() {
            const email = this.emailId;
            this.forgotPasswordButtonDisabled = true;
            this.authService.forgotPassword(email).then((details) => {
                this.forgotPasswordButtonDisabled = false;
                this.successSubmit = true;
                this.toastr.success("link send on given email");
            }).catch((err) => {
                this.toastr.clear();
                this.forgotPasswordButtonDisabled = false;
                this.toastr.error(err);
            });
        }

        hideForgotPswdView() {
            this.forgotPswd = false;
            this.successSubmit = false;
        }

        verifyEmailBackView() {
            this.forgotPswd = false;
            this.successSubmit = false;
            this.emailId = "";
        }

        submitVerifyForm() {
            this.onSubmit();
        }
	}
};


// WEBPACK FOOTER //
// ./src/app/components/auth/login/login.component.js